export const calculateBalanceDebit = ({
  spend,
  invoice,
  remainingInInvoice,
}) => {
  const used = Math.min(spend, remainingInInvoice)

  return {
    credit_used: +used.toFixed(2),
    remaining_invoice: +(remainingInInvoice - used).toFixed(2),
    remaining_spend: +(spend - used).toFixed(2),
  }
}


export const clearDebitByCusCode = async (payList, topUpList) => {
  let indexTopup = 0
  let remainingInInvoice = topUpList[0]?.remaining || 0

  const clearDebit = []
  const invoiceNoDebit = []
  const balanceDebit = []

  for (const pay of payList) {
    let spend = +pay.show_price_payment
    const invList = []

    while (spend > 0 && indexTopup < topUpList.length) {
      const inv = topUpList[indexTopup]

      const used = Math.min(remainingInInvoice, spend)

      invList.push({
        invoice_no: inv.invoice_no,
        credit_used: +used.toFixed(2),
      })

      spend -= used
      remainingInInvoice -= used

      if (remainingInInvoice === 0) {
        indexTopup++
        remainingInInvoice = topUpList[indexTopup]?.remaining || 0
      }
    }

    // map invoice → clearDebit
    for (const inv of invList) {
      clearDebit.push({
        order_number: pay.order_number,
        quo_num: pay.quo_num,
        invoice_no: inv.invoice_no,
        credit_used: inv.credit_used,
      })

      if (!invoiceNoDebit.includes(inv.invoice_no)) {
        invoiceNoDebit.push(inv.invoice_no)
      }
    }

    // เก็บ balance หลังรายการสุดท้าย
    if (pay.key === payList[payList.length - 1].key) {
      balanceDebit.push({
        inv_last: topUpList[indexTopup]?.invoice_no,
        remaining: +remainingInInvoice.toFixed(2),
      })
    }
  }

  return { clearDebit, balanceDebit, invoiceNoDebit }
}

